"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleStats = void 0;
const types_1 = require("../main/types");
class ModuleStats extends types_1.ModuleStatsType {
}
exports.ModuleStats = ModuleStats;
ModuleStats.converter = {
    toFirestore(data) {
        return {
            lastStudyDate: data.lastStudyDate,
            progress: data.progress,
            totalMaturityPoints: data.totalMaturityPoints,
            highestCorrectStreak: data.highestCorrectStreak,
            rightAcquisitionCount: data.rightAcquisitionCount,
            wrongAcquisitionCount: data.wrongAcquisitionCount,
            rightReviewCount: data.rightReviewCount,
            wrongReviewCount: data.wrongReviewCount,
            rightPracticeCount: data.rightPracticeCount,
            wrongPracticeCount: data.wrongPracticeCount,
            studyTime: data.studyTime,
            isAssigned: data.isAssigned
        };
    },
    fromFirestore(snapshot) {
        var _a;
        const documentData = snapshot.data();
        const moduleId = snapshot.id;
        const isAssigned = (_a = documentData.isAssigned) !== null && _a !== void 0 ? _a : false;
        const data = new ModuleStats(moduleId);
        data.lastStudyDate = documentData.lastStudyDate;
        data.progress = documentData.progress;
        data.totalMaturityPoints = documentData.totalMaturityPoints;
        data.highestCorrectStreak = documentData.highestCorrectStreak;
        data.rightAcquisitionCount = documentData.rightAcquisitionCount;
        data.wrongAcquisitionCount = documentData.wrongAcquisitionCount;
        data.rightReviewCount = documentData.rightReviewCount;
        data.wrongReviewCount = documentData.wrongReviewCount;
        data.rightPracticeCount = documentData.rightPracticeCount;
        data.wrongPracticeCount = documentData.wrongPracticeCount;
        data.studyTime = documentData.studyTime;
        data.isAssigned = isAssigned;
        return data;
    }
};
